import * as React from "react"

const ListItem = ({ className, children }) => {
  return (
    <li
      className={`flex flex-row items-start gap-3 pb-1 last:pb-0 ${
        className ? className : ""
      }`}
    >
      <div className={"flex-shrink-0 block h-1.5 w-1.5 mt-2.5 bg-navy"} />

      <div>{children}</div>
    </li>
  )
}

export default ListItem
